import i18n from './attribute-bundle-validator-messages.properties';

export interface AttributeBundleValidatorMessages {
  hierarchyAlreadyAddedMessage?: string;
  limitsReachedErrorMessage?: string;
  acceptedCategoriesErrorMessage?: string;
  /** Error message for when attribute's type is unknown. */
  unknownAttributeTypeErrorMessage?: string;
  acceptedAttributeTypesErrorMessage?: string;
  acceptedObjecttypeIdsErrorMessage?: string;
  acceptedGeometryTypesErrorMessage?: string;
}

export const DEFAULT_MESSAGES: AttributeBundleValidatorMessages = {
  hierarchyAlreadyAddedMessage: i18n('hierarchy-already-added'),
  limitsReachedErrorMessage: i18n('limit-reached'),
  acceptedCategoriesErrorMessage: i18n('wrong-attribute-category'),
  acceptedAttributeTypesErrorMessage: i18n('wrong-attribute-type'),
  unknownAttributeTypeErrorMessage: i18n('unknown-attribute-type'),
  acceptedObjecttypeIdsErrorMessage: i18n('wrong-objecttype'),
  acceptedGeometryTypesErrorMessage: i18n('wrong-related-geometry-type'),
} as const;
